import { render, staticRenderFns } from "./PerfilPaciente.vue?vue&type=template&id=4506de2d&scoped=true&"
import script from "./PerfilPaciente.vue?vue&type=script&lang=js&"
export * from "./PerfilPaciente.vue?vue&type=script&lang=js&"
import style0 from "./PerfilPaciente.vue?vue&type=style&index=0&id=4506de2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4506de2d",
  null
  
)

export default component.exports